import { fetchApi } from '@/config/axiosSetting.ts';
import {
  getBodyDamagedTypesQueryPropsTypes,
  getBodyDamagedTypesResponseType,
} from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/body/getBodyDamagedTypesQuery.types';

const getBodyDamagedTypesQuery = ({
  fa_name,
}: getBodyDamagedTypesQueryPropsTypes): Promise<
  getBodyDamagedTypesResponseType[]
> => {
  return fetchApi({
    method: 'GET',
    url: '/selection_item/body_damaged_type/wop_list/',
    params: { fa_name },
  });
};

export default getBodyDamagedTypesQuery;
